<template>
  <div class="contract-detail-bd" v-if="funcView.contract_detail">
    <div class="container">
      <h3 class="title">{{ $t('contractDetail.he_tong_bian_hao') }} {{ contractDetail.contractNo }}</h3>
      <p class="status flex flex-h-center">
        {{ $t('contractDetail.he_tong_zhuang_tai') }}
        <!-- {{ bizClassType === 'contract' ? '合同状态：' : '订单状态：' }} -->
        <span class="point">
          <i></i>
          {{ getDicValue('crm_contract_biz_state', contractDetail.bizState) }}
        </span>
        <span class="icon icon-xiazai download" v-if="isHasContractFile && funcView.contract_download" @click="download(contractDetail)"></span>
      </p>
      <ul class="introduction">
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contractDetail.jfsqdb') }}</p>
            <p class="name" :title="contractDetail.partyAName">{{ contractDetail.partyAName }}</p>
          </div>
        </li>
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contractDetail.yi_fang') }}</p>
            <p class="name" :title="contractDetail.customerName">{{ contractDetail.customerName }}</p>
          </div>
        </li>
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contractDetail.shou_hou_gong_si') }}</p>
            <p class="name" :title="contractDetail.afterServiceName">{{ contractDetail.afterServiceName }}</p>
          </div>
        </li>
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contractDetail.ji_qi_shu_liang') }}</p>
            <p class="name" :title="contractDetail.contractDeviceNum">{{ contractDetail.contractDeviceNum }}</p>
          </div>
        </li>
      </ul>
      <div class="info">
        <p class="line">
          {{ $t('contractDetail.he_tong_nei_rong') }}
          <span class="action" @click="showInfo = !showInfo">
            {{ showInfo ? $t('contractDetail.shou_qi') : $t('contractDetail.zhan_kai') }}
            <i class="icon" :class="{ 'icon-shouhui': showInfo, 'icon-zhankai': !showInfo }"></i>
          </span>
        </p>
        <ul class="info-box" v-show="showInfo">
          <li>
            <h4>{{ $t('contractDetail.ji_ben_xin_xi') }}</h4>
            <p class="key">
              {{ $t('contractDetail.sghth') }}
              <span class="val" :title="contractDetail.contractDeviceNum">{{ contractDetail.customContractNo }}</span>
            </p>
            <p class="key">
              {{ bizClassType === 'contract' ? $t('contractDetail.he_tong_lei_xing') : $t('contractDetail.ding_dan_lei_xing') }} {{':'}}
              <span class="val">{{ getDicValue('crm_contract_type', contractDetail.bizClass) }}</span>
            </p>
            <p class="key" v-if=" bizClassType === 'contract'">
              {{ $t('contractDetail.qian_ding_shi_chang') }}
              <span class="val">{{ contractDetail.signingDuration }}{{ $t('contractDetail.yue') }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.qian_ding_ri_qi') }}
              <span class="val">{{ $momentLocal(contractDetail.signingDate,'YYYY-MM-DD')   || '-' }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.xiang_mu_ming_cheng') }}
              <span class="val" :title="contractDetail.locationName">{{ contractDetail.locationName }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.xiang_mu_lian_xi_ren') }}
              <span class="val" :title="contractDetail.projectContactName">{{ contractDetail.projectContactName }} {{ contractDetail.projectContactPhone }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.xiang_mu_di_zhi') }}
              <span class="val" :title="contractDetail.useAddress">{{ contractDetail.useAddress }}</span>
            </p>
          </li>
          <li>
            <h4>{{ $t('contractDetail.jfsqdb') }}</h4>
            <p class="key">
              {{ $t('contractDetail.ming_cheng') }}
              <span class="val" :title="contractDetail.partyAName">{{ contractDetail.partyAName }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.lian_xi_ren') }}
              <span class="val" :title="contractDetail.salesman">{{ contractDetail.salesman }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.lian_xi_ren_dian_hua') }}
              <span class="val" :title="contractDetail.salesmanPhone">{{ contractDetail.salesmanPhone }}</span>
            </p>
          </li>
          <li>
            <h4>{{ $t('contractDetail.yi_fang') }}</h4>
            <p class="key">
              {{ $t('contractDetail.ming_cheng') }}
              <span class="val" :title="contractDetail.customerName">{{ contractDetail.customerName }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.qian_shu_ren') }}
              <span class="val" :title="contractDetail.signerName">{{ contractDetail.signerName }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.qsrdh') }}
              <span class="val" :title="contractDetail.signerPhone">{{ contractDetail.signerPhone }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.yi_fang_di_zhi') }}
              <span class="val" :title="contractDetail.customerAddress">{{ contractDetail.customerAddress }}</span>
            </p>
          </li>
          <li>
            <h4>{{ $t('contractDetail.shou_hou_gong_si') }}</h4>
            <p class="key">
              {{ $t('contractDetail.ming_cheng') }}
              <span class="val" :title="contractDetail.afterServiceName">{{ contractDetail.afterServiceName }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.lian_xi_ren') }}
              <span class="val" :title="contractDetail.technicianName">{{ contractDetail.technicianName }}</span>
            </p>
            <p class="key">
              {{ $t('contractDetail.lian_xi_ren_dian_hua') }}
              <span class="val" :title="contractDetail.technicianPhone">{{ contractDetail.technicianPhone }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="device">
        <p class="line">{{ $t('contractDetail.he_tong_ji_qi') }}</p>
        <div class="tab-box">
          <!-- {{formSearch.deviceState}} -->
          <!-- {{tableColumn}} -->
          <el-tabs v-model="formSearch.deviceState" @tab-click="onPageChange({ page: 1 })" v-if="stateCodeDic.zlz">
            <el-tab-pane :label="$t('contractDetail.dai_fa_huoo', [countDetail[stateCodeDic.dfh] || 0])" :name="stateCodeDic.dfh"></el-tab-pane>
            <el-tab-pane :label="$t('contractDetail.dai_qi_zuo', [+countDetail[stateCodeDic.ztz] || 0 + countDetail[stateCodeDic.dqz] || 0])" :name="`${stateCodeDic.ztz},${stateCodeDic.dqz}`"></el-tab-pane>
            <el-tab-pane :label="$t('contractDetail.zu_lin_zhongo', [countDetail[stateCodeDic.zlz] || 0])" :name="stateCodeDic.zlz"></el-tab-pane>
            <el-tab-pane :label="$t('contractDetail.yi_zan_tingo', [countDetail[stateCodeDic.yzt] || 0])" :name="stateCodeDic.yzt"></el-tab-pane>
            <el-tab-pane :label="$t('contractDetail.yi_geng_huano', [countDetail[stateCodeDic.ygh] || 0])" :name="stateCodeDic.ygh"></el-tab-pane>
            <el-tab-pane :label="$t('contractDetail.yi_wei_yueo', [countDetail[stateCodeDic.ywy] || 0])" :name="stateCodeDic.ywy"></el-tab-pane>
            <el-tab-pane :label="$t('contractDetail.yi_dao_qio', [countDetail[stateCodeDic.ydq] || 0])" :name="stateCodeDic.ydq"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="table-bd">
          <ul class="table-head">
            <li class="product"></li>
            <li v-for="column in tableColumn" :key="column.key" :style="{ flex: column.flex }">
              <span :title="column.name">{{ column.name }}</span>
            </li>
          </ul>
          <ul class="table-body">
            <template v-if="tableList.length > 0">
              <li class="li" v-for="item in tableList" :key="item.siteId">
                <ul class="content">
                  <li class="product">
                    <!-- <img src="http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/dev/isc/product/B1EDF6B4822B46F3BB19820DFC48B22F.jpg" /> -->
                    <img v-if="getAttachUrl(item)" :src="getAttachUrl(item)" alt />
                  </li>

                  <li v-for="column in tableColumn" :key="column.key" :style="{ flex: column.flex }">
                    <span v-if="column.code" :title="getDicValue(column.code, item[column.key]) || '-'">{{ getDicValue(column.code, item[column.key])|| '-' }}</span>
                    <span v-else-if="column.format&&column.format==='date'" :title="$momentLocal(item[column.key])  || '-'">{{ $momentLocal(item[column.key]) || '-' }}</span>
                    <span v-else-if="column.key&&column.key==='rentalTerm'" :title="`${item[column.key]} ${getDicValue(column.unitCode,item[column.unitKey])}`">{{ item[column.key] || '-' }} {{ getDicValue(column.unitCode,item[column.unitKey])|| '-'  }}</span>
                    <span v-else :title="item[column.key] || '-'">{{ item[column.key] || '-' }}</span>
                  </li>
                </ul>
              </li>
            </template>
            <template v-else>
              <li class="no-data">{{ $t('Common.com_no_data') }}</li>
            </template>
          </ul>
        </div>
        <div class="table-footer">
          <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';

// i18n-lang-component
export default {
  name: 'contractDetail',
  components: {},
  computed: {
    // 根据不同状态返回不同显示的列
    // 1. 待发货（待发货，在库中）：机器号，产品型号
    // 2. 待启租（在途中，待启租）：机器号，机身号，产品型号，发货时间，收货人，收货时间
    // 3. 租赁中：机器号，机身号 bodyNum，产品型号，启租日期，暂停天数，到期日期，租赁单价，租赁时长，付款周期，押金，售后公司，启租人
    // 4. 已暂停：机器号，机身号，产品型号，启租日期，暂停时间，租赁单价，租赁时长，付款周期，押金，售后公司
    // 5. 已更换：机器号，机身号，产品型号，启租日期，更换时间，租赁单价，租赁时长，付款周期，押金
    // 6. 已违约：机器号，机身号，产品型号，启租日期，违约时间，租赁单价，租赁时长，付款周期，押金
    // 7. 已到期：机器号，机身号，产品型号，启租日期，到期日期，租赁单价，租赁时长，付款周期，押金
    tableColumn() {
      let arr = [];
      switch (this.formSearch.deviceState) {
        // 待发货
        case this.stateCodeDic.dfh:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 2
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 2
            }
          ];
          break;
        // 待启租
        case `${this.stateCodeDic.ztz},${this.stateCodeDic.dqz}`:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('Common.com_serial_no'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contractDetail.fa_huo_shi_jian'),
              key: 'shipmentTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.shou_huo_ren'),
              key: 'deliveryUser',
              flex: 2
            },
            {
              name: this.$t('contractDetail.shou_huo_shi_jian'),
              key: 'deliveryTime',
              flex: 2,
              format: 'date'
            }
          ];
          break;
        // 租赁中
        case this.stateCodeDic.zlz:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('Common.com_serial_no'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contractDetail.qi_zu_ri_qi'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.zan_ting_tian_shu'),
              key: 'pauseDuration',
              flex: 1
            },
            {
              name: this.$t('contractDetail.dao_qi_ri_qi'),
              key: 'endRentDate',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.zu_lin_dan_jia'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contractDetail.zu_lin_shi_chang'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contractDetail.fu_kuan_zhou_qi'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contractDetail.ya_jin'),
              key: 'depositFee',
              flex: 1
            },
            // {
            //   name: '到期日期',
            //   key: 'endRentDate',
            //   flex: 2
            // },
            {
              name: this.$t('contractDetail.shou_hou_gong_si'),
              key: 'afterServiceName',
              flex: 4
            },
            {
              name: this.$t('contractDetail.qi_zu_ren'),
              key: 'rentalUser',
              flex: 2
            }
          ];
          break;
        // 已暂停
        case this.stateCodeDic.yzt:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('Common.com_serial_no'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contractDetail.qi_zu_ri_qi'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.zan_ting_shi_jian'),
              key: 'changeDate1',
              flex: 2
            },
            {
              name: this.$t('contractDetail.zu_lin_dan_jia'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contractDetail.zu_lin_shi_chang'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contractDetail.fu_kuan_zhou_qi'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contractDetail.ya_jin'),
              key: 'depositFee',
              flex: 2
            },
            {
              name: this.$t('contractDetail.shou_hou_gong_si'),
              key: 'afterServiceName',
              flex: 4
            }
          ];
          break;
        // 已更换
        case this.stateCodeDic.ygh:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('Common.com_serial_no'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contractDetail.qi_zu_ri_qi'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.geng_huan_shi_jian'),
              key: 'changeDate',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.zu_lin_dan_jia'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contractDetail.zu_lin_shi_chang'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contractDetail.fu_kuan_zhou_qi'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contractDetail.ya_jin'),
              key: 'depositFee',
              flex: 2
            }
          ];
          break;
        // 已违约
        case this.stateCodeDic.ywy:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('Common.com_serial_no'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contractDetail.qi_zu_ri_qi'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.wei_yue_shi_jian'),
              key: 'breakTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.zu_lin_dan_jia'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contractDetail.zu_lin_shi_chang'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contractDetail.fu_kuan_zhou_qi'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contractDetail.ya_jin'),
              key: 'depositFee',
              flex: 2
            }
          ];
          break;
        // 已到期
        case this.stateCodeDic.ydq:
          arr = [
            {
              name: this.$t('contractDetail.ji_qi_hao'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('Common.com_serial_no'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('Common.com_model_no'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contractDetail.qi_zu_ri_qi'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.dao_qi_ri_qi'),
              key: 'endRentDate',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contractDetail.zu_lin_dan_jia'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contractDetail.zu_lin_shi_chang'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contractDetail.fu_kuan_zhou_qi'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contractDetail.ya_jin'),
              key: 'depositFee',
              flex: 2
            }
          ];
          break;

        default:
          arr = [];
      }

      return arr;
    }
  },
  data() {
    return {
      showInfo: true,
      tableList: [],
      stateCodeDic: {},
      formSearch: {
        deviceState: '',
        bizId: '',
        search: '',
        pageNum: 1,
        pageSize: 50
      },
      totalRows: null,
      contractId: '',
      contractClass: '',
      approveType: '',
      contractDetail: {},
      countDetail: {},
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31'], // 订单类型的bizClass
      bizClassType: '', // 合同contract,订单order
      isHasContractFile: false
    };
  },
  mounted: function () {
    this.contractId = this.getJump('contractId');
    this.contractClass = this.getJump('contractClass');
    this.formSearch.bizId = this.contractId;
    if (this.contractBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'contract';
    }
    if (this.orderBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'order';
    }
    this.getFuncView('/rent/contract');
    this.getContractDetail();
    this.getTableCount();
  },
  methods: {
    // 获取合同详情
    getContractDetail: function () {
      this.$getJSON(apis.contractInfo, {
        bizId: this.contractId,
        bizClass: this.contractClass
      }).then((res) => {
        const detail = res.data;
        this.contractDetail = detail;
        this.contractDeviceNum = detail.contractDeviceNum || 0;
        this.loadContractFile(this.contractDetail);
      });
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.ContractDevicePage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.breakTime = item.endRentDate;
        });
        if (list.length > 0) {
          this.formatAttachList(list, 'productCodeId', 'dms.product.icon')
            .then((result) => {
              this.tableList = result;
            })
            .catch(() => {
              this.tableList = list;
            });
        } else {
          this.tableList = list;
        }
        this.totalRows = res.data.total;
      });
    },
    // 获取表格数据数量
    getTableCount: function () {
      this.$getJSON(apis.ContractDeviceCount, { bizId: this.contractId }).then((res) => {
        this.countDetail = res.data || {};
        // 默认第一个待发货 其他状态有设备就默认是其他状态
        let defaultState = 10;
        Object.keys(res.data).some((key) => {
          if (res.data[key] > 0) {
            defaultState = key;
            // 取一个之后退出循环
            return true;
          }
          return false;
        });
        this.getDictionary('order_device_biz_state', (data) => {
          this.stateCodeDic = this.$listTransObject(data.order_device_biz_state, 'code', 'value');
          // 在途中 待启租 合并一起用
          if (`${defaultState}` === '15' || `${defaultState}` === '21') {
            this.formSearch.deviceState = `${this.stateCodeDic.ztz},${this.stateCodeDic.dqz}`;
          } else {
            this.formSearch.deviceState = defaultState;
          }
          this.getTableList();
        });

      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    loadContractFile(contractDetail) {
      if (`${contractDetail.signingMethod}` === '1') {
        // 电子合同
        // econtractAttachment: "http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/bestSign/2021-07-26/162726616701000001.pdf"
        // 接口返回字段定义为eContractAttachment，但实际返回econtractAttachment，这里做兼容处理
        const { econtractAttachment, eContractAttachment } = contractDetail;
        if (econtractAttachment || eContractAttachment) {
          this.isHasContractFile = true;
        }
      } else {
        // 2 纸质合同
        // :bizId="contractId" bizType="crm.contract"
        const bizId = this.contractId;
        const bizType = 'crm.contract';
        if (!bizId || !bizType) {
          return;
        }
        this.$getJSON(`${apis.OssAttach}/${bizId}/${bizType}`).then((res) => {
          const list = res.data;
          if (list.length > 0) {
            this.isHasContractFile = true;
          }


        });
      }
    },
    // 下载电子合同
    download(contractDetail) {
      if (`${contractDetail.signingMethod}` === '1') {
        // 电子合同
        // econtractAttachment: "http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/bestSign/2021-07-26/162726616701000001.pdf"
        // 接口返回字段定义为eContractAttachment，但实际返回econtractAttachment，这里做兼容处理
        const { econtractAttachment, eContractAttachment } = contractDetail;
        this.jumpOutside(econtractAttachment || eContractAttachment, true);
        if (econtractAttachment || eContractAttachment) {
          this.jumpOutside(econtractAttachment || eContractAttachment, true);
        } else {
          this.$message({
            message: this.$t('contractDetail.dzhtqs'),
            type: 'error'
          });
        }
      } else {
        // 2 纸质合同
        // :bizId="contractId" bizType="crm.contract"
        const bizId = this.contractId;
        const bizType = 'crm.contract';
        if (!bizId || !bizType) {
          return;
        }
        this.$getJSON(`${apis.OssAttach}/${bizId}/${bizType}`).then((res) => {
          const list = res.data;
          if (list.length > 0) {
            this.jumpOutside(this.getAttachUrl(list[0]), true);
          } else {
            this.$message({
              message: this.$t('contractDetail.htfjqs'),
              type: 'error'
            });
          }


        });
      }

    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.contract-detail-bd {
  padding: 24px 24px 56px;
  .container {
    padding: 24px;
    background: #ffffff;
    border-radius: 16px;
    .title {
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      color: $--color-text-regular;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(0, 160, 217, 0.16);
    }

    .status {
      padding-top: 24px;
      color: $--color-text-secondary;
      font-weight: bold;
      font-size: 16px;
      line-height: 40px;
      span {
        font-weight: bold;
        font-size: 16px;
        margin-left: 5px;
        color: $--color-primary;
        i {
          width: 8px;
          height: 8px;
          display: inline-block;
          margin-right: 8px;

          background-color: $--color-primary;
          border-radius: 50%;
        }
      }

      .download {
        margin-left: auto;
        width: 40px;
        height: 40px;
        font-size: 14px;
        border: 1.5px solid $--color-text-primary;
        border-radius: 50%;
        color: $--color-text-primary;
        text-align: center;
        cursor: pointer;
      }
    }
    .introduction {
      padding-top: 24px;
      display: flex;
      li {
        height: 74px;
        padding-left: 24px;
        flex: 1;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 16px;
        flex-grow: 1;
        margin-right: 24px;
        display: flex;
        align-items: center;
        &:last-child {
          margin: 0;
        }
        .icon {
          font-size: 36px;
          color: $--color-primary;
          margin-right: 16px;
        }
        .text {
          width: 0;
          flex: 1;
          overflow: hidden;

          .key {
            font-weight: bold;
            font-size: 12px;
            line-height: 150%;
            color: $--color-text-secondary;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .name {
            font-size: 14px;
            line-height: 140%;
            color: $--color-text-regular;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .info {
      margin-top: 24px;
      padding: 24px;
      border-radius: 16px;
      border: 1px solid #f0f0f0;
      .line {
        font-weight: bold;
        font-size: 18px;
        line-height: 40px;
        color: $--color-text-primary;
        display: flex;
        justify-content: space-between;
        .action {
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          color: #818181;
          i {
            font-size: 12px;
            color: $--color-text-primary;
          }
        }
      }
      .info-box {
        margin-top: 24px;
        display: flex;
        li {
          width: 0;
          flex: 1;
          padding: 24px;
          border: 1px solid #f5f5f5;
          border-radius: 16px;
          margin-right: 16px;
          &:last-child {
            margin-right: 0px;
          }
          h4 {
            font-weight: bold;
            font-size: 12px;
            line-height: 17px;
            color: $--color-primary;
            margin-bottom: 16px;
          }
          .key {
            font-weight: bold;
            font-size: 12px;
            line-height: 140%;
            margin-bottom: 8px;
            color: $--color-text-secondary;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            .val {
              margin-left: 16px;
              font-weight: bold;
              font-size: 12px;
              line-height: 140%;
              color: $--color-text-regular;
            }
          }
        }
      }
    }
    .device {
      margin-top: 24px;
      padding: 24px;
      border-radius: 16px;
      border: 1px solid #f0f0f0;
      .el-tabs .el-tabs__item {
        font-size: 12px;
      }
      .line {
        font-weight: bold;
        font-size: 18px;
        line-height: 40px;
        color: $--color-text-primary;
        display: flex;
        justify-content: space-between;
        .action {
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          color: #818181;
          i {
            font-size: 12px;
            color: $--color-text-primary;
          }
        }
      }

      .tab-box {
        margin-top: 24px;
      }
      // 表格
      .table-bd {
        width: 100%;
        // 表头
        .table-head {
          height: 40px;
          line-height: 40px;
          display: flex;
          background-color: #fff;
          // border-radius: 16px;
          box-shadow: inset 0px -1px 0px #f0f0f0;
          li {
            padding-left: 10px;
            // text-align: center;
            color: $--color-text-secondary;
            box-sizing: border-box;
            flex: 2;
            width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              font-weight: bold;
              font-size: 14px;
              color: $--color-text-secondary;
            }
            &.product {
              flex: 2;
            }
          }
        }
        // 内容
        .table-body {
          font-size: 0;
           &>li{
             font-size: 0;
          }
          // height: 80px;
          // line-height: 80px;

          // align-content: center;
          .content {
            cursor: pointer;
            // margin-top: 16px;
            height: 64px;
            line-height: 64px;
            display: flex;
            // flex-direction: column;
            background-color: #fff;
            border-radius: 16px;
            align-content: center;
            li {
              box-sizing: border-box;
              padding-left: 10px;
              color: $--color-text-secondary;
              flex: 2;
              width: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              // text-align: center;
              span {
                color: $--color-text-regular;
                font-size: 14px;
              }
              &.product {
                flex: 2;
                padding-bottom: 0;
                display: flex;
                align-items: center;
                img {
                  max-width: 40px;
                  max-height: 40px;
                  border-radius: 8px;
                  display: inline-block;
                }
              }
            }
          }
          // 无数据
          .no-data {
            margin-top: 24px;
            height: 130px;
            text-align: center;
            line-height: 130px;
            font-size: 16px;
            color: #818181;
            background: #ffffff;
            border-radius: 16px;
          }
        }
        // 列占比
        // .site {
        //   width: 0;
        //   flex: 4;
        //   .site-info {
        //     padding-left: 25px;
        //     height: 80px;
        //     display: flex;
        //     align-items: center;
        //     font-size: 0;
        //     i {
        //       color: $--color-success;
        //       font-size: 22px;
        //       margin-right: 18px;
        //     }
        //     .text {
        //       align-self: center;
        //       display: flex;
        //       // align-items: center;
        //       flex-direction: column;
        //       p {
        //         font-weight: bold;
        //         font-size: 14px;
        //         line-height: 20px;
        //         color: $--color-text-regular;
        //       }
        //       span {
        //         font-size: 12px;
        //         line-height: 17px;
        //         text-align: left;
        //         color: $--color-text-secondary;
        //       }
        //     }
        //   }
        //   // width: 330px;
        // }
        // .area {
        //   width: 0;
        //   flex: 3;
        //   text-align: left !important;
        // }
        // .duration {
        //   width: 0;
        //   flex: 3;
        //   text-align: left !important;
        // }
        // .num {
        //   width: 0;
        //   flex: 1;
        //   text-align: center;
        //   padding: 0 !important;
        //   margin-right: 30px;
        // }
      }
      .table-footer {
        margin-top: 16px;
      }
    }
  }
}
</style>
